export const isEmail = (email: string) =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

export const hideEmail = (email: string | undefined) => {
  if (email !== undefined && email !== null) {
    let [emailToHide, domain] = email?.split("@");

    // Pegar os dois primeiros caracteres
    const firstTwoChars = emailToHide.substring(0, 2);

    // Pegar os dois últimos caracteres
    const lastTwoChars = emailToHide.substring(
      emailToHide.length - 2,
      emailToHide.length
    );

    // Substituir os caracteres do meio por asteriscos
    const hiddenChars = emailToHide
      .substring(2, emailToHide.length - 2)
      .replace(/\w/g, "*");

    return `${firstTwoChars}${hiddenChars}${lastTwoChars}@${domain}`;
  }
};
